import React from "react";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Backdrop } from "@material-ui/core";

import { SpinnerLoaderProps } from "./spinner-loader.props";
import { InnerLoaderWrapper, LoadingWrapper } from "./spinner-loader.styles";
import { SpinnerContent } from "./components/spinner-content/spinner-content.component";

export const SpinnerLoader = withShowIf((props: SpinnerLoaderProps) => {
  const { hasBackdrop, inline = false, innerLoader, size = 50 } = props;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      },
    })
  );
  const classes = useStyles();

  if (inline) {
    return <SpinnerContent color="primary" size={size} />;
  }

  if (hasBackdrop) {
    return (
      <Backdrop className={classes.backdrop} open={true}>
        <SpinnerContent color="inherit" size={size} message={props.loadingMessage} />
      </Backdrop>
    );
  }

  if (innerLoader) {
    return (
      <InnerLoaderWrapper>
        <LoadingWrapper>
          <SpinnerContent color="primary" size={size} message={props.loadingMessage} />
        </LoadingWrapper>
      </InnerLoaderWrapper>
    );
  }

  return (
    <LoadingWrapper height={props.height} padding={props.padding}>
      <SpinnerContent color="primary" size={size} message={props.loadingMessage} />
    </LoadingWrapper>
  );
});
